import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import CaldaiaForm from "./caldaiaForm";
import Actions from "../caldaieActions";
import { CaldaieStore } from "../caldaieStore";
import { CaldaiaDataDto, CaldaiaDto } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";


interface Props extends RouteComponentProps<{ id?: string }> {
}
const CaldaiaEdit = (props: Props) => {

    const { history, match } = props;
    const id = match.params.id;

    const caldaia = id ? CaldaieStore.use(+id) : new CaldaiaDto;
    if (!caldaia)
        return <Loading />

    const save = async (caldaia: CaldaiaDataDto) => {
        if (id) {
            Actions.update(+id, caldaia);
        }
        else {
            const { idCaldaia } = await Actions.add(caldaia);
            history.replace(links.caldaieEdit(idCaldaia))
        }
    }

    const dto = new CaldaiaDataDto();
    if (caldaia)
        dto.init(caldaia);

    return (
        <CaldaiaForm
            caldaia={dto}
            onSubmit={save}
            onCancel={() => history.goBack()}
        />
    );
}


export default withRouter(CaldaiaEdit);